import { nextTick, type DirectiveBinding } from 'vue'

const vScrollBottom = {
  mounted: (el: HTMLElement, binding: DirectiveBinding<boolean>) => {
    if (binding.value !== false) {
      el.scrollTop = el.scrollHeight
    }
  },
  updated: (el: HTMLElement, binding: DirectiveBinding<boolean>) => {
    if (binding.value !== false) {
      nextTick(() => {
        el.scrollTop = el.scrollHeight
      })
    }
  }
}

export default vScrollBottom
